import { ExternalLink } from '@/ui/Link/ExternalLink';

// utils
import { routes } from '@/utils/routes';

import { ByZeroEx } from './ByZeroEx';

export const ByZeroExPill = ({ className }: { className?: string }) => {
  return (
    <ExternalLink className={className} href={routes.ZEROEX_HOME}>
      <ByZeroEx />
    </ExternalLink>
  );
};
